import React from 'react'
import { Button } from 'react-bootstrap'

/**
 * WordPress (store-less) connect instructions — linking happens from the
 * PayHelm plugin in wp-admin, not via WooCommerce OAuth.
 */
export default function WordPressConnectionModalContent() {
  return (
    <div className="tw-p-2">
      <h3 className="tw-text-lg tw-font-semibold tw-mb-3">Connect WordPress</h3>
      <p className="tw-text-sm tw-text-slate-600 tw-mb-3 tw-leading-relaxed">
        Install the PayHelm plugin on your WordPress site (WooCommerce not required). Open{' '}
        <strong>PayHelm</strong> in wp-admin and sign in to link the site for AI site tools,
        pages, media, and settings — without WooCommerce store data.
      </p>
      <ol className="tw-text-sm tw-text-slate-600 tw-mb-4 tw-pl-5 tw-list-decimal tw-space-y-1">
        <li>Install &amp; activate the PayHelm plugin on WordPress</li>
        <li>Open PayHelm in the WordPress admin menu</li>
        <li>Sign in to your PayHelm account to finish linking</li>
      </ol>
      <div className="tw-flex tw-flex-wrap tw-gap-2">
        <Button
          variant="primary"
          size="sm"
          href="https://wordpress.org/plugins/payhelm-for-woocommerce/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get the plugin
        </Button>
        <Button
          variant="outline-secondary"
          size="sm"
          href="https://www.payhelm.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more
        </Button>
      </div>
    </div>
  )
}
